export * from './nevis.service';
import { NevisService } from './nevis.service';
export const APIS = [NevisService];
